import BaseService from "./BaseService";
import BaseFilter from './BaseFilter';

export class ChangeLogService extends BaseService {
	constructor() {
		super('/changelog');
	}

	public getAllByFilter(filter: ChangeLogFilter) {
		return super.getAllByFilterBase(filter);
	}

	public confirm(data: any) {
		return super.updateBase(this._resourceName + '/confirm', data);
	}
}

export class ChangeLogFilter extends BaseFilter {
	constructor(idTenant?: number | null) {
		super();
		this._idTenant = idTenant;
	}

	private _idTenant?: number | null;


	public getAllParams(): {} {
		let data = Object.assign({},
			(this._idTenant != null ? { IdTenant: this._idTenant } : {})
		);

		return data;
	};
}